import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ClientesListLayer from '../components/ClientesListLayer';
import ProdutosListLayer from '../components/ProdutosListLayer';
import RelatorioLayer from '../components/RelatorioLayer';

const RelatorioPage = () => {
    
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Relatórios - Lista" icon="solar:chart-square-outline" />

            {/* UsersListLayer */}
            <RelatorioLayer />
        </>
    );
};

export default RelatorioPage;
